<template>
    <v-container>
        <v-layout row align-center justify-center>
            <v-flex xs12 sm6 offset-m3>
                <v-card>
                    <v-card-title><h1>Login</h1></v-card-title>
                    <v-card-text>
                        <v-container>
                            <form @submit.prevent='onLogin'>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="email"
                                            label="email"
                                            id="email"
                                            v-model="email"
                                            type="email"
                                            required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                            name="password"
                                            label="password"
                                            id="password"
                                            v-model="password"
                                            type="password"
                                            required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-spacer></v-spacer>
                                    <v-flex xs2>
                                        <v-btn class="buttonColorLight" type="submit">Login</v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  watch: {
    authenticatedUser (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    }
  },
  computed: {
    authenticatedUser () {
      return this.$store.getters.authenticatedUser
    }
  },
  methods: {
    onLogin () {
      this.$store.dispatch('loginUser', { email: this.email,
        password: this.password })
    }
  }
}
</script>
<style>
.v-btn.theme--light.buttonColorLight {color: black}
</style>
